import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { usePartnerAuth } from '../../contexts/PartnerAuthContext';

const PartnerProtectedRoute = ({ children }) => {
  const { token, initializing, authenticating } = usePartnerAuth();
  const location = useLocation();

  if (initializing || authenticating) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!token) {
    return <Navigate to="/partner/login" replace state={{ from: location }} />;
  }

  return children;
};

export default PartnerProtectedRoute;
